import React, { useEffect, useState } from "react";
import Button from "modules/Common/Components/Button";
import styled from "styled-components";
import Cross from "../../../../assets/img/icons/cross.svg";

import { Modal } from "antd";

const ExportPopupStyle = styled.div<{ open?: any }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  position: absolute;
  /* top: 30%;
  left: 35%; */
  top: -190px;
  border-radius: 30px;
  background-color: #ffffff;
  width: 550px;
  height: 380px;
  z-index: 11;
  opacity: 1;
  box-shadow: 0px 0px 20px 1px grey;
  padding: 45px;
  h1 {
    font-size: 42px;
    font-family: "robotomedium";
    color: #5e7079;
  }
  .upper-text {
    font-family: "robotoregular";
    font-size: 20px;
    color: #5e7079;
  }
  .lower-text {
    font-family: "robotomedium";
    font-size: 20px;
    color: #5e7079;
  }
  .close-popup {
    cursor: pointer;
    float: right;
    margin-top: -25px;
    margin-right: -25px;
  }
`;


const ExportErrorWrapper = styled.div<{ open?: boolean }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  position: absolute;
  border-radius: 30px;
  background-color: #ffffff;
  width: 350px;
  height: 200px;
  z-index: 11;
  opacity: 1;
  padding: 45px;
  top: -190px;
  box-shadow: 0px 0px 20px 1px grey;
  h2 {
    font-size: 42px;
    font-family: "robotomedium";
    color: #5e7079;
  }
  .close-popup {
    cursor: pointer;
    float: right;
    margin-top: -25px;
    margin-right: -25px;
  }
`;

interface IExportPopup {
  headerText?: string;
  showPopup?: boolean;
  showErrorPopup?: boolean;
  exportEmail?: string;
  resendEmail?: () => void;
  onClosePopup?: () => void;
}

const GeneralExportPopup: React.FC<IExportPopup> = (props: IExportPopup) => {
  const { showPopup, showErrorPopup, exportEmail, resendEmail, onClosePopup } = props;

  useEffect(() => {
    // const bodyElement = (document.getElementsByTagName("body") as HTMLCollectionOf<HTMLElement>)[0];
    // if (showPopup || showErrorPopup) {
    //   window.scrollTo(0, 0);
    //   bodyElement.classList.add("overlay-nav-without-scroll");
    // } else {
    //   bodyElement.classList.remove("overlay-nav-without-scroll");
    // }
  }, [showPopup, showErrorPopup]);

  return (
    <StyledModal
      visible={showPopup || showErrorPopup}
      title=""
      footer={null}
      closable={false}
      centered={true}
    >
      {/* <Wrapper open={showPopup || showErrorPopup} onClick={onClosePopup}></Wrapper> */}
      <ExportPopupStyle open={showPopup} {...props}>
        <span className="close-popup" onClick={onClosePopup}>
          <img src={Cross} alt="x" />
        </span>
        <h1>Export Audience</h1>
        <p className="upper-text">An email has been sent to “{exportEmail}” with the download link</p>
        <p className="lower-text">
          If you don't receive the email within 5 minutes, please check your SPAM folder as well
        </p>
        <div>
          <Button
            value={"Resend Email"}
            onClick={() => {
              if (resendEmail) resendEmail();
            }}
          />
        </div>
      </ExportPopupStyle>
      <ExportErrorWrapper open={showErrorPopup}>
        <span className="close-popup" onClick={onClosePopup}>
          <img src={Cross} alt="x" />
        </span>
        <h2>Something went wrong</h2>
      </ExportErrorWrapper>
    </StyledModal>
  );
};
export default GeneralExportPopup;


const StyledModal = styled(Modal)`
  .ant-modal-content {
    background: transparent;
    background-clip: padding-box;
    box-shadow: none;
    .ant-modal-header {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .ant-modal-title {
        margin: 0;
        font-family: "Roboto";
        color: #424b50;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        word-wrap: break-word;
      }
    }
    /* border-radius: 8px; */
    /* box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.0821427); */
  }
`;
